import {
    CentralPathRowSet,
    mapModelToCentralPathRowSet,
} from 'app/shared/features/map-row-selector/models/central-path-row-set';
import { GreenHouseMapModel } from 'app/shared/features/map-row-selector/models/server/green-house-map-model';

export const mapModelToGreenHouseMap = (model: GreenHouseMapModel): GreenHouseMap => {
    const centralPathRowSets = model.centralPathRowSets.map(mapModelToCentralPathRowSet);
    return { ...model, centralPathRowSets };
};

export interface GreenHouseMap {
    name: string;
    number: number;
    centralPathRowSets: CentralPathRowSet[];
}
